import React from "react";

export default function Modal({ isOpen, onClose, children }) {
  if (!isOpen) return null;

  return (
    <div
      className="modal-backdrop fade-in-backdrop"
      onClick={onClose}
    >
      <div
        className="modal-container scale-in"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content">
          <button
            onClick={onClose}
            className="modal-close-x"
            aria-label="Close modal"
          >
            &times;
          </button>
          {children}
        </div>
      </div>
    </div>
  );
}
